import { Component } from "react";
import "./SelectWithModal.css";
import AsyncSelect from "react-select/async";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ValidateIcon from "@mui/icons-material/Check";
import { withStyles } from "@mui/styles";
import { DialogTitle, FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class SelectWithModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpenned: false,
            values: this.props.value,
        };
    }

    validate() {
        this.props.onValidate(this.state.values);
        this.close();
    }

    forceValidate(forceValues) {
        this.props.onValidate(forceValues);
        this.close();
    }

    onSelectMenuOpen() {
        this.setState({ modalOpenned: true });
    }

    modalOnChange(e) {
        let values = e.target.value;
        this.setState({ values });

        if (!this.props.multiple) this.forceValidate(values);
    }

    close() {
        this.setState({ modalOpenned: false });
    }

    render() {
        const { classes } = this.props;
        let selectElement;

        if (this.props.async)
            selectElement = (
                <AsyncSelect
                    autoFocus
                    {...this.props}
                    value={this.state.values}
                    className="full_size"
                    menuPlacement="auto"
                    classNamePrefix="select"
                    noOptionsMessage={() => "Aucune valeur"}
                    onChange={this.modalOnChange.bind(this)}
                />
            );
        else
            selectElement = (
                <FormControl className="row">
                    <InputLabel id="ot-label">{this.props.label}</InputLabel>
                    <CustomizedSelect
                        autoFocus
                        {...this.props}
                        value={this.state.values}
                        className="full_size"
                        menuPlacement="auto"
                        classNamePrefix="select"
                        noOptionsMessage={() => "Aucune valeur"}
                        menuclasses="select-popup"
                        onChange={this.modalOnChange.bind(this)}
                    />                    
                </FormControl>
            );

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <FormControl className="row without-side-padding">
                    <InputLabel id="ot-label">{this.props.label}</InputLabel>
                    <CustomizedSelect
                        labelId={"solution-label-" + this.props.label}
                        id={"solution-" + this.props.label}
                        label={this.props.label}
                        placeholder={
                            this.props.placeholder || "Sélectionner ..."
                        }
                        {...this.props}
                        isClearable={false}
                        menuclasses="select-popup"
                        onOpen={this.onSelectMenuOpen.bind(this)}
                        open={this.state.modalOpenned}
                        className="full_size"
                        menuPlacement="auto"
                        classNamePrefix="select"
                    />                  
                </FormControl>
                <Dialog
                    aria-labelledby="simple-dialog-title"
                    fullScreen
                    open={this.state.modalOpenned}
                    onClose={this.close.bind(this)}
                >
                    <DialogTitle className="without-padding">
                        <AppBar className={"appbar"} position="static">
                            <Toolbar>
                                <IconButton
                                    color="inherit"
                                    onClick={this.close.bind(this)}
                                    aria-label="Close"
                                >
                                    <CloseIcon />
                                </IconButton>
                                <Typography
                                    variant="h6"
                                    color="inherit"
                                    className={classes.flex}
                                >
                                    {this.props.label}
                                </Typography>
                                <IconButton
                                    color="inherit"
                                    onClick={this.validate.bind(this)}
                                    aria-label="Validate"
                                >
                                    <ValidateIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                    </DialogTitle>
                    <DialogContent className="without-padding">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 div-top-padding">
                            {selectElement}
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(SelectWithModal);
